import { render, staticRenderFns } from "./InstructorCreate.vue?vue&type=template&id=6ea917d6&"
import script from "./InstructorCreate.vue?vue&type=script&lang=ts&"
export * from "./InstructorCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports